/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { clsx } from '~go/web/src/js/utils/clsx/clsx';
import './scroll_shadow_wrapper.css';
import { useMeasure } from 'react-use';

// eslint-disable-next-line react/display-name
const ScrollShadowWrapperX = forwardRef(
  ({ children, className, scrollContainerProps, color1, color2, width, innerContainerProps, ...props }, ref) => {
    const [innerRef, { width: measureWidth }] = useMeasure();
    const [leftStyle, setLeftStyle] = useState({});
    const [rightStyle, setRightStyle] = useState({});

    const setScrollStyles = e => {
      const setStyles = ({ scrollLeft, scrollWidth, clientWidth }) => {
        // @see https://stackoverflow.com/questions/3898130/check-if-a-user-has-scrolled-to-the-bottom-not-just-the-window-but-any-element
        const isRight = Math.abs(scrollWidth - scrollLeft - clientWidth) < 1;
        const isLeft = scrollLeft === 0;

        if (!isLeft) {
          setLeftStyle({ background: `linear-gradient(90deg, ${color1} 0%, transparent 100%)` });
        } else {
          setLeftStyle({ background: 'none' });
        }
        if (!isRight) {
          setRightStyle({ background: `linear-gradient(90deg, transparent 0%, ${color2} 100%)` });
        } else {
          setRightStyle({ background: 'none' });
        }
      };

      if (ref?.current) {
        setStyles(ref.current);
      } else if (e?.target) {
        setStyles(e.target);
      }
    };

    useLayoutEffect(() => {
      setScrollStyles();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measureWidth]);

    return (
      <div className={clsx('position-relative overflow-hidden', className)} {...props}>
        <div className="scroll-shadow left" style={{ ...leftStyle, width }} />
        <div
          ref={ref}
          onScroll={setScrollStyles}
          {...scrollContainerProps}
          className={clsx('scroll-x w-100 disable-scrollbar', scrollContainerProps.className)}
        >
          <div ref={innerRef} {...innerContainerProps}>
            {children}
          </div>
        </div>
        <div className="scroll-shadow right" style={{ ...rightStyle, width }} />
      </div>
    );
  }
);

ScrollShadowWrapperX.defaultProps = {
  className: '',
  color1: 'white',
  color2: 'white',
  width: 40,
  scrollContainerProps: {},
  innerContainerProps: {},
};

ScrollShadowWrapperX.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color1: PropTypes.string,
  color2: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scrollContainerProps: PropTypes.shape(),
  innerContainerProps: PropTypes.shape(),
};

export default ScrollShadowWrapperX;
